'use strict';

module.exports = function isLeadingSurrogate(charCode) {
	return typeof charCode === 'number' && charCode >= 0xD800 && charCode <= 0xDBFF;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/isLeadingSurrogate.js
// module id = 815
// module chunks = 231608221292675